module.exports = __webpack_public_path__ + "img/179.4bdc5751.jpg";